import React, { useEffect, useState } from 'react';
import { Image, ScrollView, Text, TouchableOpacity, View } from 'react-native';
import { MaterialIcons } from "@expo/vector-icons";

import Cryptos from '../../data/crypto'
import { styles } from './styles';
import AsyncStorage from '@react-native-async-storage/async-storage';
import activesService from '../../services/activesService';

const CryptoListSelection = ({ onItemPressed }) => {
  // TODO: Change onItemPressed parameters to something usefull, this is just a prototype

  const [cryptos, setCryptos] = useState([]);
  const [actives, setActives] = useState([]);
  const [authToken, setAuthToken] = useState('');

  useEffect(() => {
    loadToken();
  }, []);

  useEffect(() => {
    if(authToken.length > 0) {
      loadAllActives();
    }
  }, [authToken]);

  useEffect(() => {
    let cryptoAr = [];
    actives.map((el) => {
      if(el.cryptoactive) {
        cryptoAr.push(el);
      }
    }, []);
    setCryptos(cryptoAr);
  }, [actives]);

  const loadToken = async () => {
    const token = await AsyncStorage.getItem('JWT_TOKEN');
    setAuthToken(token);
  }

  const loadAllActives = () => {
      activesService.get(authToken).then((response) => {
          if (response.data.length > 0) {
              setActives(response.data[0]);
          }
      }).catch((error) => {
          console.log(error);
      });
  }

  const onItemPressHandler = (el) => {
    let minValue = 0.01;//fixed
    let minTransfer = 0.01;//fixed
    let depositFee = 0;//fixed
    let withdrawFee = 2;//fixed
    let transferFee = 0.99;//percent
    if(el.name_token === 'ADA') {
      minValue = 10;
      minTransfer = 10;
      depositFee = 0;
      withdrawFee = 2;
      transferFee = 0.99;
    }else if(el.name_token === 'ETH') {
      minValue = 0.01;
      minTransfer = 0.016;
      depositFee = 0;
      withdrawFee = 0.009;
      transferFee = 0.99;
    } else if (el.name_token === 'BTC') {
      minValue = 0.001;
      minTransfer = 0.0008;
      depositFee = 0;
      withdrawFee = 0.0006;
      transferFee = 0.99;
    }
    onItemPressed({      
      activeId: el.id,
      name: el.name_token,
      acronym: el.name_token,
      minValue: minValue,
      minTransfer: minTransfer,
      step: 0.0001,
      depositFee: depositFee,
      withdrawFee: withdrawFee,
      transferFee: transferFee
    })
  }

  return (
    <ScrollView style={styles.container}>
      {
        cryptos.map((el, index) => 
          <TouchableOpacity
            key={index}
            onPress={() => onItemPressHandler (el)}
            style={styles.listItem}
          >
            <Image
              style={styles.icon}
              resizeMode="contain"
              source={{uri: `https://filesgpx.s3.us-east-2.amazonaws.com/${el.path}`}}
            />
            <View style={styles.itemTextSection}>
              <Text style={styles.textBold}>{el.name_token}</Text>
            </View>
            <MaterialIcons
              name="keyboard-arrow-right"
              size={24}
              color="#2C2C2E"
              style={styles.iconGo}
            />
          </TouchableOpacity>
        )
      }
      {/* <TouchableOpacity
        onPress={() => onItemPressed(Cryptos.BTC)}
        style={styles.listItem}
      >
        <Image
          style={styles.icon}
          resizeMode="contain"
          source={require("../../../assets/imgs/bitcoin.png")}
        />
        <View style={styles.itemTextSection}>
          <Text style={styles.textBold}>Bitcoin (BTC) - Desativado</Text>
        </View>
        <MaterialIcons
          name="keyboard-arrow-right"
          size={24}
          color="#2C2C2E"
          style={styles.iconGo}
        />
      </TouchableOpacity>
      <TouchableOpacity
        onPress={() => onItemPressed(Cryptos.ETH)}
        style={styles.listItem}>
        <Image
          style={styles.icon}
          source={require("../../../assets/imgs/ethereum.png")}
        />
        <View style={styles.itemTextSection}>
          <Text style={styles.textBold}>Ethereum (ETH ) - Desativado</Text>
        </View>
        <MaterialIcons
          name="keyboard-arrow-right"
          size={24}
          color="#2C2C2E"
          style={styles.iconGo}
        />
      </TouchableOpacity>
      <TouchableOpacity
        onPress={() => onItemPressed(Cryptos.ADA)}
        style={styles.listItem}>
        <Image
          style={styles.icon}
          source={require("../../../assets/imgs/cardano.png")}
        />
        <View style={styles.itemTextSection}>
          <Text style={styles.textBold}>Cardano (ADA)</Text>
        </View>
        <MaterialIcons
          name="keyboard-arrow-right"
          size={24}
          color="#2C2C2E"
          style={styles.iconGo}
        />
      </TouchableOpacity> */}
    </ScrollView>
  );
}

export default CryptoListSelection;